import Alpine from 'alpinejs';
import Clipboard from "@ryangjchandler/alpine-clipboard";
import Flickity from 'flickity';
//Local script for nav
import MainNav from  './mainNav'; 
import SecondaryNav from './secondaryNav';
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'

// import login from './login';
import api from './api';
import api_data from './key';

import { searchClient } from './searchClient';
import algoliasearch from 'algoliasearch';
import { autocomplete } from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';

import instantsearch from 'instantsearch.js'
import historyRouter from 'instantsearch.js/es/lib/routers/history'
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { hits, pagination, configure } from 'instantsearch.js/es/widgets'
import { snippet } from 'instantsearch.js/es/helpers'

import Tooltip from "@ryangjchandler/alpine-tooltip";

import '@algolia/autocomplete-theme-classic';

import impexLogin from './impexLogin';

//Start blog search
const INSTANT_SEARCH_INDEX_NAME = 'Blog'
const instantSearchRouter = historyRouter()

const search = instantsearch({
  searchClient,
  indexName: INSTANT_SEARCH_INDEX_NAME,
  routing: instantSearchRouter,
})

// Mount a virtual search box to manipulate InstantSearch's `query` UI
// state parameter.
const virtualSearchBox = connectSearchBox(() => {})

const has_hits = document.getElementById('hits');
if(has_hits) {
    search.addWidgets([
      virtualSearchBox({}),
      configure({
        attributesToSnippet: ['content:20'],
      }),
      hits({
        container: '#hits',
        templates: {
          item: `
            <a href="{{ url }}"  class="blog-card" data-id='{{ objectID }}'>
              <div class="content">
                <img src=""/>
                <div class="HomeBlog-postText p-4">
                    <p class="tag text-gray-dark">{{ category }}</p>
                    <h5 class="text-blue-navy">{{ title }}</h5>

                    <p>{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}</p>
                    <div class="flex items-center">
                      <div class="flex items-center mt-6">
                          <span class="text-blue-baby">Read More</span>
                          <img src="{{ mix('/assets/dist/images/icons/next.svg') }}" class="ml-2 h-5" />
                      </div>
                    </div>
                </div>
              </div>
            </a>
          `,
          empty(results, { html }) {
            return html`No results for <q>${results.query}</q>`;
          },
        },
      }),
      pagination({
        container: '#pagination',
      }),
    ]);

    search.on('render', () => {
      if (search.status === 'stalled') {
        console.log('rendering');
      } else {
        console.log('done');
        var hits = document.getElementById('hits');
        var cards = hits.getElementsByClassName('blog-card');
        for (let i =0; i< cards.length; i++){
          var id = cards[i].getAttribute('data-id');
          console.log(id);
          const xhttp_getimage = new XMLHttpRequest();
          xhttp_getimage.onload = function() {
            cards[i].getElementsByTagName('img')[0].src = this.responseText;
          }
          xhttp_getimage.open("GET", "/blog/image?id=" + id, true);
          xhttp_getimage.send();
        }
      }
    })
        
    search.start()
}

function getimage(item) {
  console.log(item);
}
// Set the InstantSearch index UI state from external events.
function setInstantSearchUiState(indexUiState) {
  search.setUiState(uiState => ({
    ...uiState,
    [INSTANT_SEARCH_INDEX_NAME]: {
      ...uiState[INSTANT_SEARCH_INDEX_NAME],
      // We reset the page when the search state changes.
      page: 1,
      ...indexUiState,
    },
  }))
}

// Return the InstantSearch index UI state.
function getInstantSearchUiState() {
  const uiState = instantSearchRouter.read()

  return (uiState && uiState[INSTANT_SEARCH_INDEX_NAME]) || {}
}

const searchPageState = getInstantSearchUiState()

const querySuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: 'Blog_query_suggestions',
  getSearchParams() {
    return {
      hitsPerPage: 10,
    };
  },
});

const has_autocomplete = document.getElementById('autocomplete');
if(has_autocomplete) {
    autocomplete({
      container: '#autocomplete',
      placeholder: 'Search',
      openOnFocus: true,
      plugins: [querySuggestionsPlugin],
    });
}

const has_search = document.getElementById('search_autocomplete');
if(has_search) {
    autocomplete({
      container: '#search_autocomplete',
      placeholder: 'Search',
      initialState: {
        query: searchPageState.query || '',
      },
      onSubmit({ state }) {
        setInstantSearchUiState({ query: state.query })
      },
      onReset() {
        setInstantSearchUiState({ query: '' })
      },
      onStateChange({ prevState, state }) {
        if (prevState.query !== state.query) {
          setInstantSearchUiState({ query: state.query })
        }
      },
      openOnFocus: true,
      plugins: [querySuggestionsPlugin],
    });
}

const blog_search = document.getElementById('autocomplete');

if(blog_search) {
    const blog_form = blog_search.getElementsByTagName('form')[0];
    blog_form.onsubmit = function() {
        var query = blog_form.getElementsByTagName('input')[0].value;
        window.location.href = '/blog/results?Blog[query]=' + query;
    }
}

//end blog search

//start site search
const INSTANT_SITE_SEARCH_INDEX_NAME = 'All'

const all_search = instantsearch({
  searchClient,
  indexName: INSTANT_SITE_SEARCH_INDEX_NAME,
  routing: instantSearchRouter,
})

const all_virtualSearchBox = connectSearchBox(() => {})

const has_all_hits = document.getElementById('site_hits');

if(has_all_hits) {
    all_search.addWidgets([
      virtualSearchBox({}),
      configure({
        attributesToSnippet: ['content:100'],
      }),
      hits({
        container: '#site_hits',
        templates: {
          item: `
            <a href="{{ url }}">
              <div class="content">
                <h5 class="text-blue-navy">{{ title }}</h5>
                <p>{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}{{ treatmentSummary }}</p>
              </div>
            </a>
          `,
          empty(results, { html }) {
            return html`No results for <q>${results.query}</q>`;
          },
        },
      }),
      pagination({
        container: '#site_pagination',
      }),
    ]);

    all_search.on('render', () => {
      if (all_search.status === 'stalled') {
        console.log('rendering');
      } else {
        console.log('done');
      }
    })
        
    all_search.start()
}

function setSiteInstantSearchUiState(indexUiState) {
  all_search.setUiState(uiState => ({
    ...uiState,
    [INSTANT_SITE_SEARCH_INDEX_NAME]: {
      ...uiState[INSTANT_SITE_SEARCH_INDEX_NAME],
      // We reset the page when the search state changes.
      page: 1,
      ...indexUiState,
    },
  }))
}

function getSiteInstantSearchUiState() {
  const uiState = instantSearchRouter.read()

  return (uiState && uiState[INSTANT_SITE_SEARCH_INDEX_NAME]) || {}
}

const searchAllPageState = getSiteInstantSearchUiState()

const queryAllSuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: 'All_query_suggestions',
  getSearchParams() {
    return {
      hitsPerPage: 10,
    };
  },
});

const has_site_search = document.getElementById('site_search_autocomplete');
if(has_site_search) {
    autocomplete({
      container: '#site_search_autocomplete',
      placeholder: 'What are you looking for?',
      initialState: {
        query: searchAllPageState.query || '',
      },
      onSubmit({ state }) {
        setSiteInstantSearchUiState({ query: state.query })
      },
      onReset() {
        setSiteInstantSearchUiState({ query: '' })
      },
      onStateChange({ prevState, state }) {
        if (prevState.query !== state.query) {
          setSiteInstantSearchUiState({ query: state.query })
        }
      },
      openOnFocus: true,
      plugins: [queryAllSuggestionsPlugin],
    });
}

const site_search = document.getElementById('site_search');

if(site_search) {
    autocomplete({
      container: '#site_search',
      placeholder: 'What are you looking for?',
      openOnFocus: true,
      plugins: [queryAllSuggestionsPlugin],
    });

    const search_form = site_search.getElementsByTagName('form')[0];
    if(search_form) {
      search_form.onsubmit = function() {
        var query = site_search.getElementsByTagName('input')[0].value;
        window.location.href = '/results?All[query]=' + query;
      }
    }
}

// end site search


function outsideClick(event, notelem)   {
    //notelem = $(notelem); // jquerize (optional)
    // check outside click for multiple elements
    var clickedOut = true, i, len = notelem.length;
    for (i = 0;i < len;i++)  {
        if (event.target == notelem[i] || notelem[i].contains(event.target)) {
            clickedOut = false;
        }
    }
    if (clickedOut) return true;
    else return false;
}

const search_open = document.getElementById('open');
const search_form = document.getElementById('autocomplete');
if(search_form && search_open) {
    search_open.onclick = function(){
        event.preventDefault();
        search_form.classList.toggle('open');
        search_open.classList.toggle('open');
    };
    
}
 
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(persist)
Alpine.plugin(Clipboard)
Alpine.plugin(Tooltip);

document.addEventListener('alpine:init', () => {

    Alpine.data('MainNav', MainNav); 
    Alpine.data('SecondaryNav', SecondaryNav); 

    Alpine.directive('flickity',(el, { value, modifiers, expression }, { Alpine, evaluate, cleanup }) => {
        const flickity = new Flickity(el,evaluate(expression));
    });

    Alpine.magic('flickity', () => { return Flickity });

    Alpine.directive('pinned', (el, {val, mpd, exp}, { Alpine, evaluate, cleanup}) => {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
            { threshold: [1] }
        )

        observer.observe(el);
    });
    
    /*
      * Usage:
      * x-breakpoint:max.1024 
      * @breakpoint="isMobile = $event.detail.matches"
      * 
      */
    Alpine.directive('breakpoint', (el, { value, modifiers, expression }, { Alpine, evaluateLater, effect, cleanup }) => {  
        let mql = window.matchMedia(`(${value}-width: ${modifiers[0]}px)`);   

        // console.log(`@breakpoint: (${value}-width: ${modifiers[0]}px)`)
        // console.log(mql)
        
        // for initial value
        el.dispatchEvent(new CustomEvent('breakpoint', {
            detail: { matches: mql.matches },
            bubbles: true,
        })); 
            
        mql.addEventListener('change', e => {
            // console.log(e)
            el.dispatchEvent(new CustomEvent('breakpoint', {
                detail: { matches: e.matches },
                bubbles: false,
            }));
        });
        
        cleanup(() => {
            mql.removeEventListener('change');
        });

    });
});

window.Alpine = Alpine;
 
Alpine.start();
